import React from 'react';
import { Modal, Timeline } from 'antd';
import styles from './timeline.module.scss';
import COButton from 'shared/components/COButton';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import {
  BACK_BUTTON_TEXT,
  PROCEED_BUTTON_TEXT,
  TIMELINE_MODAL_TITLE,
  TIMELINE_STEPS,
} from './constants';
import { modalCloseIcon } from 'shared/components/OrganizationModal';
interface TimelineModalProps {
  isVisible: boolean;
  onClose: () => void;
  onProceed: () => void;
}

const TimelineModal: React.FC<TimelineModalProps> = ({
  isVisible,
  onClose,
  onProceed,
}) => {
  return (
    <Modal
      visible={isVisible}
      onCancel={onClose}
      closeIcon={modalCloseIcon}
      footer={null}
      wrapClassName={styles.timeLine}
      width={490}>
      <h2 className={styles.Heading}>{TIMELINE_MODAL_TITLE}</h2>
      <Timeline>
        {TIMELINE_STEPS.map((step, index) => (
          <Timeline.Item
            key={index}
            dot={
              <div
                className={`${styles.customDot} ${
                  index === TIMELINE_STEPS.length - 1 ? styles.lastDot : ''
                }`}>
                {step.stepNumber}
              </div>
            }>
            <div className={styles.content}>
              <h3
                className={
                  index === TIMELINE_STEPS.length - 1 ? styles.lastItem : ''
                }>
                {step.title}
              </h3>
              <h5
                className={
                  (index === TIMELINE_STEPS.length - 1 ? styles.lastItem : '',
                  styles.subTitle)
                }>
                {step.description}
              </h5>
            </div>
          </Timeline.Item>
        ))}
      </Timeline>
      <div className={styles.buttonContainer}>
        <div className={styles.singleButtonContainer}>
          <COButton onClick={onProceed}>{PROCEED_BUTTON_TEXT}</COButton>
          <COButton secondary onClick={onClose}>
            {BACK_BUTTON_TEXT}
          </COButton>
        </div>
      </div>
    </Modal>
  );
};

export default TimelineModal;
